import { render, staticRenderFns } from "./addre-data.vue?vue&type=template&id=f754a570&scoped=true&"
import script from "./addre-data.vue?vue&type=script&lang=js&"
export * from "./addre-data.vue?vue&type=script&lang=js&"
import style0 from "./addre-data.vue?vue&type=style&index=0&id=f754a570&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f754a570",
  null
  
)

export default component.exports